/* eslint-disable */
// /src/context/DriverStatusContext.jsx
import React, { createContext, useContext } from "react";
import { useDriverStatus } from "../hooks/useDriverStatus";

const DriverStatusContext = createContext(null);

export function DriverStatusProvider({ children }) {
    const value = useDriverStatus(); // ✅ 여기서만 실제 훅 호출

    return (
        <DriverStatusContext.Provider value={value}>
            {children}
        </DriverStatusContext.Provider>
    );
}

export function useDriverStatusContext() {
    const ctx = useContext(DriverStatusContext);
    if (!ctx) {
        throw new Error("useDriverStatusContext must be used within DriverStatusProvider");
    }
    return ctx;
}
